// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Card,
  CardContent,
  Fab,
  Fade,
  IconButton,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import ReviewsIcon from "@mui/icons-material/Reviews";
import DOMPurify from "dompurify";
import { publicBannerConfig } from "../../config/constant";

const PublicNotificationBannerCard = () => {
 
  const bannerId = "2024-12-01-public-banner";

  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (localStorage.getItem(bannerId) === "hide") {
      setOpen(false);
    }
  }, []); // Empty dependency array - run only on mount

  // Only show if SHOW_PUBLIC_BANNER is true and content exists
  if (!publicBannerConfig.SHOW_PUBLIC_BANNER || !publicBannerConfig.bannerContent) {
    return null;
  }

  return (
    <>
      <Slide
        timeout={1000}
        direction="left"
        in={open}
        mountOnEnter
        unmountOnExit
      >
        <Card
          sx={{
            width: "60%",
            position: "fixed",
            top: 100,
            right: 20,
            zIndex: "1000",
            borderRadius: 5,
            py: 3,
            px: 1,
          }}
          elevation={3}
        >
          <Stack
            sx={{ mr: 1, mt: -2 }}
            direction="row"
            justifyContent="flex-end"
          >
            <IconButton
              aria-label="Close notification banner"
              onClick={() => {
                setOpen(false);
                localStorage.setItem(bannerId, "hide");
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <CardContent sx={{ marginTop: -2 }}>
            {publicBannerConfig.bannerTitle && (
              <Typography
                sx={{ fontWeight: "bold" }}
                variant="h5"
                color="secondary.main"
              >
                {publicBannerConfig.bannerTitle}
              </Typography>
            )}

            <Typography 
              variant="body1" 
              mt={2} 
              dangerouslySetInnerHTML={{ 
                __html: DOMPurify.sanitize(publicBannerConfig.bannerContent) 
              }} 
            />
          </CardContent>
        </Card>
      </Slide>
      <Fade in={!open} timeout={1000}>
        <Fab
          aria-label="Show notification banner"
          sx={{
            position: "fixed",
            bottom: 100,
            right: 0,
            zIndex: "1000",
          }}
          onClick={() => {
            setOpen(true);
            localStorage.setItem(bannerId, "show");
          }}
          color="secondary"
        >
          <ReviewsIcon />
        </Fab>
      </Fade>
    </>
  );
};

export default PublicNotificationBannerCard;
